import { render, staticRenderFns } from "./EditProfileDialog.vue?vue&type=template&id=d1434e4c&scoped=true"
import script from "./EditProfileDialog.vue?vue&type=script&lang=js"
export * from "./EditProfileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1434e4c",
  null
  
)

export default component.exports